import { render, staticRenderFns } from "./update-price.vue?vue&type=template&id=7c53bc72&scoped=true&"
import script from "./update-price.vue?vue&type=script&lang=js&"
export * from "./update-price.vue?vue&type=script&lang=js&"
import style0 from "./update-price.vue?vue&type=style&index=0&id=7c53bc72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53bc72",
  null
  
)

export default component.exports